import React, { useState } from 'react';
import style from './style.module.scss';
import ButtonIcon from "../../../../../../../components/ButtonIcon/ButtonIcon";
import CaretRight from "../../../../../../../assets/svg/icons/common/CaretRight";
// import ChildTable from "./ChildTable";
import CheckCircle from "../../../../../../../assets/svg/icons/common/CheckCircle";
import MinusCircle from "../../../../../../../assets/svg/icons/common/MinusCircle";
import { formatCurrency } from '../../../../../../../../components/helper/helper';

// Card image mapping
const CARD_IMAGES = {
  Visa: "/images/visa24x24.svg",
  Mastercard: "/images/master24x24.svg",
  Amex: "/images/amex24x24.svg",
  Discover: "/images/discover24x24.svg",
  Debit: "/images/debit24x24.svg",
  EBT: "/images/ebt24x24.svg",
  MC: "/images/master24x24.svg",
  VS: "/images/visa24x24.svg",
  VD: "/images/visa24x24.svg",
  DS: "/images/discover24x24.svg",
  MD: "/images/debit24x24.svg",
  AM: "/images/amex24x24.svg",
  VB: "/images/visa24x24.svg",
  DD: "/images/ebt24x24.svg",
  MB: "/images/master24x24.svg",
};

const Row = ({ data }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <tr className={style.table_row}>
        {/* <td className={style.table_cell}>
          <ButtonIcon
            bgColor={"#FF"}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            className={`${isOpen ? style.collapse_button : ""}`}
          >
            <CaretRight />
          </ButtonIcon>
        </td> */}
        <td className={style.table_cell}>
          <div className={style.cardInfo}>
            {CARD_IMAGES[data?.card_type] && (
              <img src={CARD_IMAGES[data?.card_type]} alt={data?.card_type} className={style.cardIcon} />
            )}
            <span>{data?.card_type}</span>
          </div>
        </td>
        <td className={`${data?.code == "Sale" ? style.text_green : style.text_red} ${style.code_cell}`}>
          <div className={style.code_cell_content}>
            {data?.code == "Sale" ? <CheckCircle /> : <MinusCircle />}
            {data?.code}
          </div>
        </td>
        <td className={style.table_cell}>{data?.transaction_count}</td>
        <td className={`${data?.code == "Sale" ? style.text_green : style.text_red} ${style.total_cell}`}>
          $ {data?.total_amount ? formatCurrency(data?.total_amount): "0.00"}
        </td>
      </tr>
      {/* {isOpen && <ChildTable data={data?.batches_data_details} />} */}
    </>
  );
}

export default Row